/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const AnnualIncomeSchema = z.enum(["NOT_PROVIDED", "NOT_REQUIRED", "UNDER_25000", "FROM_25000_TO_49999", "FROM_50000_TO_74999", "FROM_75000_TO_99999", "FROM_100000_TO_149999", "MORE_THAN_150000"])
